<template>
  <div style="width:100%">
    <el-header  style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header>
    <el-main>
    <h3>{{$t('field.announcementContent')}}</h3>
    *說明:若公告內容需附圖，請至下方附件處先上傳圖檔，再以「{imgpath:圖檔名稱(包含附檔名)}」插入想附圖的內文位置，一則公告限放一張圖檔
      <el-row style="padding: 5px;">  
      <el-col :span="10" >
        <el-button type="success" @click="addTableData()">{{$t('button.create')}}</el-button>  
      </el-col>   
      <el-col :span="4" :offset="10">   
          <el-input v-model="searchText" :placeholder="$t('msg.fuzzySearch')" >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
      </el-col>  
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table  size="mini" :ref="tableId" :id="tableId" :data="tableData.data.slice((currentPage-1)*pagesize,currentPage*pagesize)" border highlight-current-row 
        :empty-text="$t('msg.noDataFound')" style="width: 100%"  height="600">    
       
          <el-table-column v-for="(v, i) in tableData.columns" :prop="v.field" :label="v.title" :width="v.width" :key="i" sortable>
            <template slot-scope="scope">            
              <span v-if="currentIndex==scope.$index">                
                <el-date-picker  v-if="v.type=='date' && (scope.row['action']=='A'|| (scope.row['action']=='U' && !v.notUpdate))" v-model="tableData.sel[v.field]"  type="date"  :placeholder="$t('msg.selectDate')" size="mini" style="width: 100%;"></el-date-picker>
                <el-select v-else-if="v.type=='select' && (scope.row['action']=='A'|| (scope.row['action']=='U' && !v.notUpdate))" v-model="tableData.sel[v.field]" :placeholder="$t('msg.pleaseSelect')" size="mini">
                  <el-option v-for="item in v.selectObj" :key="item" :label="item" :value="item"></el-option>
                </el-select>  
                <el-input v-else-if="v.type=='textarea' && (scope.row['action']=='A'|| (scope.row['action']=='U' && !v.notUpdate))" v-model="tableData.sel[v.field]"  type="textarea"  :placeholder="$t('msg.pleaseEnterContent')" size="mini" style="width: 100%;" :maxlength=v.maxlength  show-word-limit rows=5></el-input>
                <el-input v-else-if="(v.type!='date' &&v.type!='select' &&v.type!='textarea') && 
                                (scope.row['action']=='A'|| (scope.row['action']=='U' && !v.notUpdate))" size="mini" :placeholder="$t('msg.pleaseEnterContent')" v-model="tableData.sel[v.field]" ></el-input>
                <span v-else>{{ scope.row[v.field] }}</span>
              </span>
              <span v-else>{{ scope.row[v.field] }}</span>
            </template>
          </el-table-column>
       

          <el-table-column :label="$t('action')" width="240" class="dont-export">    

            <template slot-scope="scope">    
              <el-button v-if="currentIndex!=scope.$index" type="warning" @click="updTableData(scope.row, scope.$index, true)">{{$t('button.edit')}}</el-button>
              <el-button v-if="currentIndex==scope.$index" type="success" @click="updTableData(scope.row, scope.$index, true)">{{$t('button.confirm')}}</el-button>
              <el-button v-if="currentIndex!=scope.$index" type="danger" @click="delTableData(scope.row, scope.$index)">{{$t('button.delete')}}</el-button>    
              <el-button v-if="currentIndex==scope.$index" type="warning" @click="updTableData(scope.row, scope.$index, false)">{{$t('button.cancel')}}</el-button>
              <el-button v-if="currentIndex!=scope.$index" type="success" @click="preview(scope.row, scope.$index, false)">{{$t('button.preview')}}</el-button>
            </template>
          </el-table-column>
        </el-table>   
        <div style="text-align: center;margin-top: 10px;">
          <el-pagination ref="pageTool" background layout="prev, pager, next" :total="tableData.data.length" :page-size.sync="pagesize" :current-page.sync="currentPage"  @current-change="current_change"></el-pagination>
        </div>   
      </el-col>
    </el-row>
    <h3>{{$t('field.announcementAttachmentEdit')}}</h3>
    <FileEditList ref="fileList"  docId="announcement" uploadType="other"  @sync-save-status="syncFileSave" :directSave="true"/>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="70%" @opened="openAnnounceDialog" @closed="closeAnnounceDialog" >         
      <p id="dialogContent"></p>
      <img :src="dialogPic" alt="" style=" max-height: 100%; max-width: 100%; "/>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">{{$t('button.confirm')}}</el-button>
      </span>
    </el-dialog>
    </el-main>
  </div>
</template>

<script>
import Breadcrumb from "../components/Breadcrumb.vue";
import FileEditList from "../components/FileEditList";
import { apiFindAllAnnouncementData, apiSaveAnnouncementData, apiDeleteAnnouncementById } from "../../utils/api.js";
import authHeader from "../../services/auth-header";
import AWSUtil from "../../utils/AWSUtil";
import CommonUtil from "../../utils/commonUtil.js";

export default {
  name: 'announcementMaintain',
  data() {
    return {
      tableId:'announcementTable',
      pagesize: 5,
      currentPage: 1,
      currentIndex:-1,
      searchText: '',  
      dialogVisible: false,
      dialogTitle:'',
      dialogContent:'',
      dialogPic: '',
      tableData: {
        sel: null,
        columns: [    
          { field: "startDate", title: "Start Date", width: 150 ,  type:'date'},
          { field: "endDate", title: "End Date", width: 150 , type:'date'},
          { field: "enabledStr", title: "Enabled", width: 100 , required:true, type:'select', selectObj:['Y','N']},
          { field: "role", title: "Role", width: 100 , required:true, type:'select', selectObj:['ALL','OA','CUSTOMER']},
          { field: "sort", title: "Sort", width: 80 },
          { field: "title", title: "title", width: 250, required:true,type:'textarea', maxlength:1000 },
          { field: "content", title: "content", width:500, required:true,type:'textarea', maxlength:2000  }
        ],
        originalTableData:[],
        data: []        
      },
    };
  },
  components: {
    Breadcrumb,
    FileEditList
  },
  mounted() { 
    this.readData();
  },
  created(){
    this.tableData.columns.forEach((item) => {
        console.log('>>>'+document.documentElement.clientWidth);
        if(item.field == 'content'){
          item.width = (document.documentElement.clientWidth>1400?'auto':500);
        }
      });          
  },
  watch: { 
    searchText () {   
      const search = (this.searchText!=null ? this.searchText.toLowerCase() : '');
      if (search) {   
        let displayCol = [];

        this.tableData.columns.forEach((item, index) => {
          if(item.field != null && item.field!= ''){
            displayCol.push(item.field);
          }
        });
              
        this.tableData.data  = this.tableData.originalTableData.filter(dataNews => {
          return Object.keys(dataNews).some(key => {
            var inColumn = false;
            for (var col of this.tableData.columns) {
              if(col.field == key){
                inColumn = true;                
                break;
              }
            }            
            if(inColumn) return String(dataNews[key]).toLowerCase().indexOf(search) > -1
          })
        })
      }else{
         this.tableData.data = this.tableData.originalTableData.filter(dataNews => {
          return Object.keys(dataNews).some(key => {
            return String(dataNews[key]).toLowerCase().indexOf('') > -1
          })
        })
      }
    },
    currentPage(){
     
      if(this.currentIndex!=-1){
        //表示當前有資料正在修改,不可換頁
        this.currentPage = this.$refs['pageTool'].currentPage;
      }

    },
    "tableData.data"(){ 
      this.currentPage= 1;
      this.$refs['pageTool'].currentPage= 1;
    }
  },
  methods: {
    current_change:function(currentPage){      
        
      if(this.currentIndex!=-1){  
        this.tableData.currentPage = this.currentPage ;
        this.$message.warning({message:this.$i18n.t('msg.saveFirst'), duration: 800});
        this.$refs['pageTool'].currentPage = this.currentPage;
        return false
      }else{
        this.currentPage = currentPage;
      }     
      
    },    
    addTableData() {         
      if(this.currentIndex!=-1){
        return this.$message.warning({message:this.$i18n.t('msg.saveFirst'), duration: 800});
      }
      var emptyData = {};   
      this.tableData.columns.forEach((item, index) => {
        emptyData[item.field] = '';        
      });

      emptyData['action']='A';
      this.tableData.data.splice(0, 0, emptyData);
      this.tableData.sel = JSON.parse(JSON.stringify(emptyData));
      this.currentIndex = 0;

    },  
    updTableData(row, index, cg) {      
      //是否是取消操作
      if (!cg) {
        if (!this.tableData.sel.id) this.tableData.data.splice(index, 1);
        return this.currentIndex = -1;;
      }
      if(this.currentIndex !=-1 && index != this.currentIndex){
        return this.$message.warning({message:this.$i18n.t('msg.saveFirst'), duration: 800});
      } 
      row.action = 'U';
      if (this.currentIndex !=-1 && index == this.currentIndex) {     
        let data = JSON.parse(JSON.stringify(this.modifyUpdData(this.tableData.sel)));
        var a = this.checkRequired(data);
        if(a){
          return this.$message.warning({message:this.$i18n.t('msg.incompleteInfo'), duration: 800});
        }else{
          // for (let k in data) row[k] = data[k];  
          this.$refs[this.tableId].setCurrentRow();        
          this.currentIndex = -1;
          this.saveData(data);
        }
       
      } else {
        this.tableData.sel = JSON.parse(JSON.stringify(this.modifyUpdData(row)));
        this.$refs[this.tableId].setCurrentRow(row);
        this.currentIndex = index;
      }
    },
    checkRequired(data){
      let check = false;
      for (var col of this.tableData.columns) { 
        if(col.required && (data[col.field] ==null || data[col.field] == '')){
          check = true;
        }
      }
      return check;
    },
    modifyUpdData(data){      
      for (var col of this.tableData.columns) {
        //employee date datetime select
        if(data[col.field]!=null && data[col.field] != ''){

          if(col.type == 'date'){
            var value = String(data[col.field]);           
            
            if(value != null && value.indexOf('-') == -1 && value.length ==8){              
              data[col.field] = value.substring(0,4) + '-' + value.substring(4,6) + '-' + value.substring(6,8);
            }
            var d = new Date(data[col.field]);
            if(d!=null){
              data[col.field] = d.getFullYear() + "-" + this.lpad(d.getMonth()+1, 2) + "-" + this.lpad(d.getDate(), 2);	
            }
            
          }
        }        
      }  
      return data;
    },
    lpad (str,length){
	  if(String(str).length >= length)
		 return str;
	  else
	    return this.lpad("0" +String(str),length);
	},
    delTableData(row, index){        
      this.$confirm(this.$i18n.t('msg.confirmDelete'), {
        confirmButtonText: this.$i18n.t('button.confirm'),
        cancelButtonText: this.$i18n.t('button.cancel'),
        type: 'warning'
      }).then(_ => {
        var currentIndex = this.pagesize * (this.currentPage-1) + index;   
        this.tableData.data.splice(currentIndex, 1);
        this.deleteData(row);
        done();
      }).catch(_ => {});     
    },  
    readData(){
      this.tableData.data = [];
      this.tableData.originalTableData =  [];  
      apiFindAllAnnouncementData({ headers: authHeader() }).then((response) => {  
        response.data.forEach((item, index) => { 
          item.enabledStr = (item.enabled==0?'N':'Y');
            var reg=new RegExp("<br>","g");
            item.content = item.content.replace(reg,"\n");  
            if(item.startDate != null && item.startDate != ''){        
              item.startDate = CommonUtil.dateFormatDate(item.startDate);
            }
            if(item.endDate != null && item.endDate != ''){        
              item.endDate = CommonUtil.dateFormatDate(item.endDate);
            } 
        });
        this.tableData.data = response.data;
        this.tableData.originalTableData =  this.tableData.data;    
      }).catch((err) => {
        console.log(err);
      });
    },
    saveData(data){      
      data.enabled = (data.enabledStr=='Y'?1:0);
      data.content = data.content.replace(/\n|\r\n/g,"<br>");      
      apiSaveAnnouncementData({  headers: authHeader(), saveData : data}).then((response) => {        
                  
        if(response.status == 200){
          this.readData();
          this.$message.success({message: this.$i18n.t('msg.saveSuccess'), duration: 800});
        }else{          
          this.$message.error({message: this.$i18n.t('msg.saveFail'), duration: 1000});
        }           
      
      }).catch((err) => {        
          this.$message.error({message: this.$i18n.t('msg.saveFail'), duration: 1000});
          console.log(err);
      });
    },
    deleteData(data){    
      apiDeleteAnnouncementById({  headers: authHeader(), deleteId : data.id}).then((response) => {               
        if(response.status == 200){
          this.$message.success({message: this.$i18n.t('msg.deleteSuccess'), duration: 800});
        }else{
          this.$message.error({message: this.$i18n.t('msg.deleteFail'), duration: 800});
        }
      }).catch((err) => {
        this.$message.error({message: this.$i18n.t('msg.deleteFail'), duration: 1000});
          console.log(err);
      });
    },
    syncFileSave(status){
     
    },
    preview(data, index, cg){
    
      this.dialogTitle = data.title;
      this.dialogContent = data.content;     
      
      if(data.content.indexOf('{imgpath:') >-1){
        let arr = data.content.split('{imgpath:');
        if(arr!= null && arr.length >1){
          this.dialogContent = arr[0];    
          let imgPath = arr[1].substring(0,arr[1].indexOf('}'));          
          this.dialogPic= AWSUtil.getUrlPath()+'other/announcement/'+imgPath;//require('..//assets/announce/'+imgPath)
        }
      }else{
        this.dialogPic = '';
      }
      this.dialogVisible= true;
    },
    closeAnnounceDialog(){
      this.dialogContent = '';    
      this.dialogPic='';
      var element = document.getElementById('dialogContent');
      element.innerHTML = this.dialogContent;
    },
    openAnnounceDialog(){
      var element = document.getElementById('dialogContent');
      element.innerHTML = this.dialogContent;
    },
  }
};
</script>